import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

import circleCheck from 'icons/circle-check.svg';

export const Wrapper = styled.section`
	padding: 40px 0;
	text-align: center;
	background-color: ${palette('white')};

	${minWidth('tablet')} {
		padding: 40px 0 80px;
	}
`;

export const TableWrapper = styled.div`
	margin: 0 auto;
	max-width: 960px;
	padding: 0 16px;
	position: relative;
	width: 100%;

	${minWidth('mobileLarge')} {
		padding: 0 24px;
	}

	${minWidth('desktop')} {
		padding: 0 36px;
	}

	${minWidth('desktopLarge')} {
		max-width: 1168px;
	}
`;

export const FeatureBackground = styled.div<{ $top: number }>`
	background: ${palette('blue3')};
	border-radius: 16px;
	opacity: 0.1;
	position: absolute;
	bottom: 0;
	right: 16px;
	top: ${p => p.$top}px;
	width: calc(20% - 8px);
	z-index: -1;

	${minWidth('tablet')} {
		right: 24px;
		width: calc(20% - 12px);
	}

	${minWidth('desktop')} {
		right: 36px;
		width: calc(20% - 18px);
	}
`;

export const Table = styled.table`
	border-collapse: collapse;
	width: 100%;
`;

export const Heading = styled(Text).attrs({
	color: 'blue3',
	fontSize: FontSizes.xl,
	weight: FontWeights.Regular,
	lineHeight: FontSizes.xl,
	el: 'h2',
})`
	margin-top: 0;
	margin-bottom: 8px;

	${minWidth('tablet')} {
		font-size: 49.5px;
	}
`;

export const Subheading = styled(Text).attrs({
	el: 'p',
})`
	color: ${palette('gray8')};
	font-size: 20px;
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 40px;

	${minWidth('tablet')} {
		font-size: 31.5px;
	}
`;

export const FeatureRow = styled.tr`
	border-bottom: 2px ${palette('gray2')} solid;
	margin: 0;
`;

export const FeatureCell = styled.td`
	padding: 24px 0;
	width: 20%;

	&:first-of-type {
		width: 60%;
	}
`;

export const Thead = styled.thead`
	border-bottom: 2px ${palette('gray2')} solid;
`;

export const FeatureHeading = styled(Text).attrs({
	color: 'gray8',
	fontSize: FontSizes.sm,
	lineHeight: FontSizes.xl,
	weight: FontWeights.Medium,
	noMargin: true,
	el: 'span',
})`
	${minWidth('tablet')} {
		font-size: 22.5px;
	}
`;

export const FeatureText = styled.td`
	color: ${palette('gray8')};
	font-size: 12px;
	${fontWeight(FontWeights.Medium)};
	padding: 24px 0;
	width: 20%;

	${minWidth('tablet')} {
		font-size: 18px;
	}

	&:first-of-type {
		font-size: 16px;
		text-align: left;
		width: 60%;

		${minWidth('tablet')} {
			font-size: 18px;
		}
	}
`;

export const CircleCheck = styled(circleCheck)`
	height: 20px;
	width: 20px;

	${minWidth('tablet')} {
		height: 32px;
		width: 32px;
	}

	& path {
		fill: ${palette('blue3')};
	}
`;

export const FeatureListEnd = styled.tfoot`
	align-items: flex-end;
	margin-top: 16px;
	padding-bottom: 16px;
`;

export const LimitedTimeOfferText = styled.td`
	color: ${palette('gray8')};
	padding: 24px 0;
	text-align: left;
	transform: translateX(-64px);

	${minWidth('tablet')} {
		text-align: right;
	}
`;

export const Pricing = styled.td`
	padding: 24px 0;
	text-align: center;
`;

export const StrikethruPrice = styled(Text).attrs({
	color: 'gray6',
	lineHeight: FontSizes.xl,
	weight: FontWeights.Regular,
	el: 'p',
})`
	display: inline-block;
	margin-top: 0;
	margin-bottom: 8px;
	position: relative;
	font-size: ${FontSizes.base}rem;

	${minWidth('tablet')} {
		font-size: ${FontSizes.xl}rem;
	}

	&:after {
		background: ${palette('gray6')};
		content: '';
		position: absolute;
		height: 2px;
		left: -5px;
		right: -5px;
		transform-origin: top right;
		transform: rotate(-15deg);
		top: 8px;
	}
`;

export const DiscountPrice = styled(Text).attrs({
	color: 'gray8',
	lineHeight: FontSizes.xl,
	weight: FontWeights.Medium,
	noMargin: true,
	el: 'p',
})`
	font-size: ${FontSizes.base}rem;

	${minWidth('tablet')} {
		font-size: ${FontSizes.xl}rem;
	}
`;

export const ButtonWrapper = styled.div`
	margin: 40px auto 0;
	padding: 0 16px;

	${minWidth('mobileLarge')} {
		padding: 0 24px;
	}

	${minWidth('desktop')} {
		padding: 0 36px;
	}
`;

export const HiddenLabel = styled.span`
	border: 0;
	clip: rect(0 0 0 0);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
	white-space: nowrap;
`;

export const PriceWrapper = styled.div`
	position: relative;
`;
